import {get, post, postJson,deleteApi} from '../axios'
// 精准营销

// const RESOURCE_BASE_PATH = '/jd-yusms'
// const RESOURCE_BASE_PATH = 'http://116.196.113.156/jd-yusms'
const RESOURCE_BASE_PATH = '/shortLink'
const RESOURCE_BASE_PATH1 = '/sellerLinkConfig'


// 获取短连接
export const getShortLink = p => get(`${RESOURCE_BASE_PATH}/`, p);

// 查询链接列表分页接口
export const getSellerLinkConfig = p => get(`${RESOURCE_BASE_PATH1}/page`, p);

// 删除链接接口
export const deleteLink = id => deleteApi(`${RESOURCE_BASE_PATH1}/delete/${id}`)

// 保存链接接口
export const saveLink = p => postJson(`${RESOURCE_BASE_PATH1}/save`, p);

